import {FabricImage, classRegistry} from 'fabric';

/*
 * Fabric 5 allowed stamping an Image with `type: 'video'` via constructor
 * options; v6+ derives `type` from the class, so videos need a subclass for
 * both runtime checks and serialization to keep producing type 'video'.
 */
export class FabricVideo extends FabricImage {
    static type = 'video';
}

classRegistry.setClass(FabricVideo);
